import { CService } from "./class.base.service";

class PermissionService extends CService{}
const permissionService = new PermissionService("permissions");
export default permissionService